import * as React from 'react';
import { fetchFeatureFlags } from '../actions/fetchFeatureFlags';
import { FlagsProvider } from 'flagged';
import { mappedFeatureFlags } from '../../../helpers/featureFlags';
import { CommonRootState } from '../../../combineReducers';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

export const FeatureFlagWrapper: React.FC = ({ children }) => {
  const dispatch = useDispatch();
  const { featureFlags } = useSelector((state: CommonRootState) => state.featureFlags);

  useEffect(() => {
    if (featureFlags.length === 0) {
      dispatch(fetchFeatureFlags());
    }
  }, [dispatch, featureFlags]);

  const mappedFeatures = featureFlags && mappedFeatureFlags(featureFlags);

  return <FlagsProvider features={mappedFeatures}>{children}</FlagsProvider>;
};
